// General-purpose functions/helpers

// Shorter alias for querySelector
window.get = document.querySelector.bind(document)
window.getAll = document.querySelectorAll.bind(document)

// Create global timer object
const timers = {}

const helpers = {
	
	delay: (callback, ms, name="default") => {
		clearTimeout(timers[name])
		timers[name] = setTimeout(callback, ms)
	},
	
	isDOM: el => el instanceof Element,
	
	on: (events, selectors, handler, doc=document, controller=false) => {
		
		if (selectors) {
			
			// Convert events string to array
			events = events.split(' ')
			
			// Loop through events
			for (const event of events) {
				
				// Convert selector string to array
				if (typeof selectors === "string") selectors = selectors.split(',')
				
				// Loop through selectors
				for (const selector of selectors) {
					doc.addEventListener(event, e => {
						let target = e.target
						while (target != null) {
							if (target.matches && target.matches(selector)) {
								if (handler) handler.call(target, e)
								return
							}
							target = target.parentElement
						}
					}, true, { signal: controller.signal || false })
				}
				
			}
			
		} else {
			
			// No selector, use entire doc
			doc.addEventListener(events, e => {
				handler.call(e.target, e)
			}, true)
			
		}
		
	},
	
	getValue: el => {
		let value
		if (el.matches('[type="checkbox"]')) {
			value = el.checked ? true : false
		} else {
			value = el.value
		}
		return value
	},
	
	escapeQuotes: content => content.replace(/[""]/g, '\''),
	
	random: (min=0, max=1000) => Math.floor(Math.random() * (max - min + 1)) + min,
	
	urnify: input => {
		let urn = input.toLowerCase()
		urn = urn.replace('&', 'and')
		urn = urn.replace('/', '-')
		urn = urn.replace(' ', '-')
		urn = urn.replace(/-+/g, '-')
		urn = urn.replace(/^-+/g, '')
		urn = urn.replace(/[^a-z0-9-]/g, '')
		return urn
	},
	
	subdomainify: input => {
		let urn = input.toLowerCase()
		urn = urn.replace('&', 'and')
		urn = urn.replace('/', '')
		urn = urn.replace(' ', '')
		urn = urn.replace(/-+/g, '')
		urn = urn.replace(/^-+/g, '')
		urn = urn.replace(/[^a-z0-9-]/g, '')
		return urn
	},
	
	boolean: value => {
		if (value === "false") value = false
		if (value === "0") value = false
		if (value === 0) value = false
		if (value === "true") value = true
		if (value === "1") value = true
		if (value === 1) value = true
		return value
	},
	
	formToJSON: form => {
		const json = {}
		const formData = new FormData(form)
		for (const key of formData.keys()) {
			json[key] = formData.get(key)
		}
		return json 
	},
	
	stringToBool: string => string === 'false' ? false : !!string,
	
	triggerEvent: (event, element) => {
		const e = new Event(event, {
			bubbles: true,
			cancelable: true,
		})
		element.dispatchEvent(e)
	},
	
	stretchyField: function() {
		this.parentNode.dataset.value = this.value
	},
	
	autosave: () => {
		
		helpers.on('input', '[data-autosave]', function() {
			
			// Save elements
			const input = this
			// const form = input.closest('form')
			const feedback = input.closest('div').querySelector('.js-feedback')
			
			// Reset error messages
			feedback.textContent = ""
			feedback.classList.remove('success')
			feedback.classList.remove('error')
			
			delay(async () => {
				
				// Get variables
				const action = input.dataset.autosave
				const method = "post"
				const body = {}
				body[input.name] = input.value
				
				// Send request
				const response = await fetch(action, {
					method: method,
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify(body),
				})
				
				// log('response', response)
				
				// Parse response
				data = await response.json()
				
				// Show error message
				feedback.textContent = data.message
				feedback.classList.add(data.status)
				
				log('data', data)
				
				// Handle errors
				// if (data.errors) {
				// 	log('errors', data.errors)
				// 	for (errorName of Object.keys(data.errors)) {
				// 		this.querySelector(`.error.${errorName}`).textContent = data.errors[errorName]
				// 	}
				// }
				
				return data
				
			}, 500)
			
		})
		
	},
	
	back: () => {
		helpers.on('click', '.js-back', e => {
			e.preventDefault()
			history.back()
		})
	},
	
	toElement: string => {
		const container = document.createElement('div')
		container.innerHTML = string.trim()
		const element = container.firstChild
		return element
	},
	
	elementFromTemplate: (templateSelector, data) => {
		// Get template from page based on ID
		const template = document.querySelector(`${templateSelector}`)
		// Return if it doesn't exist
		if (!template) return false
		// Grab content
		let content = template.innerHTML
		// Perform replacements
		for (const key in data) {
			const regex = new RegExp(`{{${key}}}`, "g")
			content = content.replace(regex, data[key])
		}
		// Convert to HTML element
		const container = document.createElement('div')
		container.innerHTML = content.trim()
		const element = container.firstChild
		// Return
		return element
	},
	
	// toElement: string => document.createRange().createContextualFragment(string),
	// This causes errors when changing datasets of the fragements before appending to do document
	
	empty: el => el.innerHTML = "",
	
	unwrap: el => {
		let parent = el.parentNode
		while (el.firstChild) parent.insertBefore(el.firstChild, el)
		parent.removeChild(el)
	},
	
	wrap: (el, wrapperString) => {
		let wrapper = tt.toElement(wrapperString)
		el.parentNode.insertBefore(wrapper, el)
		wrapper.appendChild(el)
		return wrapper
	},
	
	insertBefore: (element, reference) => {
		if (typeof element === "string") {
			element = helpers.toElement(element)
		}
		reference.parentNode.insertBefore(element, reference)
	},
	
	insertAfter: (element, reference) => {
		if (typeof element === "string") {
			element = helpers.toElement(element)
		}
		reference.parentNode.insertBefore(element, reference.nextSibling)
	},
	
	isJSON: data => {
		if (typeof data === "object") {
			return true
		} else {
			return false
		}
	},
	
	prevAll: (element, type=false) => {
		const result = []
		while (element = element.previousElementSibling) {
			if (type) {
				if (element.matches(type)) {
					result.push(element)
				}
			} else {
				result.push(element)
			}
		}
		return result
	},
	
	nextAll: (element, type=false) => {
		const result = []
		while (element = element.nextElementSibling) {
			if (type) {
				if (element.matches(type)) {
					result.push(element)
				}
			} else {
				result.push(element)
			}
		}
		return result
	},
	
	request: {
		
		post: async (url, data={}) => {
			
			// Convert from formdata to normal object
			data = helpers.formDataToObject(data)
			
			const options = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data),
			}
			
			try {
				const response = await fetch(url, options)
				const json = await response.json()
				return json
			} catch (err) {
				return err
			}
			
		},
		
		get: async (url, data={}) => {
			
			url = url + "?" + new URLSearchParams(data)
			
			const response = await fetch(url)
			const text = await response.text()
			
			try {
				const data = JSON.parse(text)
				return data
			} catch (err) {
				return text
			}
			
		},
		
	},
	
	formDataToObject: data => {
		if (data instanceof FormData) {
			const object = {}
			data.forEach((value, key) => object[key] = value)
			data = object
		}
		return data
	},
	
	cleanArray: array => {
		var filtered = array.filter((el) => {
			// return el != null
			return el != ""
		})
		return filtered
	},
	
	escapeRegExp: string => string.replace(/[.*+?^${}()\-|[\]\\]/g, '\\$&'),
	
	escapeHTML: html => {
		// Escape HTML
		html = document.createElement('div')
			.appendChild(document.createTextNode(html))
			.parentNode
			.innerHTML
		// Escape quotes
		html = html.replace(/[""]/g, '\\"')
		return html
	},
	
	hasValue: (object, value) => {
		return Object.values(object).some(function(val) {
			if (val === value) {
				return true
			}
			if (val && typeof val === 'object') {
				return helpers.hasValue(val, value)
			}
			if (val && Array.isArray(val)) {
				return val.some((obj) => {
					return helpers.hasValue(obj, value)
				})
			}
		})
	},
	
	isEmpty: object => Object.keys(object).length === 0,
	
	contrastColor: hex => {
		
		// Remove hash
		if (hex.indexOf('#') === 0) hex = hex.slice(1)
		
		// convert 3-digit hex to 6-digits
		if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
		
		// Validate
		if (hex.length !== 6) throw new Error('Invalid HEX color')
		
		const r = parseInt(hex.slice(0, 2), 16)
		const g = parseInt(hex.slice(2, 4), 16)
		const b = parseInt(hex.slice(4, 6), 16)
		
		return ((r * 0.299 + g * 0.587 + b * 0.114) > 186) ? '#000000' : '#ffffff'
		
	},
	
	extend: (obj1, obj2) => {
		const recursiveMerge = (obj, entries) => {
			for (const [key, value] of entries) {
				if (typeof value === "object") {
					obj[key] = obj[key] ? {...obj[key]} : {}
					recursiveMerge(obj[key], Object.entries(value))
				} else {
					obj[key] = value
				}
			}
			return obj
		}
		return recursiveMerge(obj1, Object.entries(obj2))
	},
	
	titleCase: string => {
		return string.replace(/\w\S*/g, txt => {
			return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
		})
	},
	
	searchObject: (obj, key, value) => {
		if (obj[key] === value) return obj
		for (const v of Object.values(obj)) {
			if (v && typeof v === 'object') {
				const result = helpers.searchObject(v, key, value)
				if (result) return result
			}
		}
		return null
	},
	
	setNestedProperty: (obj, path, value) => {
		const keys = path.split('.')
		keys.reduce((acc, key, index) => {
			if (index === keys.length - 1) {
				acc[key] = value
			} else {
				acc[key] = acc[key] ?? {}
			}
			return acc[key]
		}, obj)
	},
	
	getSearchParam: param => {
		const url = window.location.href
		const urlObj = new URL(url)
		const params = new URLSearchParams(urlObj.search)
		const value = params.get(param)
		return value || false
	},
	
	// Sanitize file name
	sanitizeFilename: ({ filename, length=100, unique=true}) => {
		
		// Save original for later
		const original = filename
		
		let filenameParts = filename.toLowerCase().split('.') // Split filename into name and extension
		let extension = filenameParts.pop()
		let name = filenameParts.join('-') // Replace any periods with dashes
		name = name.replace(/[^a-z0-9]/gi, '-') // replace non-alphanumeric characters with dashes
		name = name.replace(/-+/gi, '-') // consolidate multiple dashes
		name = name.replace(/(^-|-$)/gi, '') // trim dashes from beginning/end
		
		// Truncate filename if too long
		name = name.substring(0, length)
		
		// Random suffix to avoid collisions
		let suffix = ""
		if (unique) suffix = `-${helpers.random(100000, 999999)}`
		
		filename = `${name}${suffix}.${extension}`
		
		// Return
		return {
			name,
			suffix,
			extension,
			filename,
			original,
		}
		
	},

}

export default helpers
